import React from "react";
import MUIInputLabel from "@mui/material/InputLabel";
import MUITextField from "@mui/material/TextField";
import { extractFormFieldError, getClassName } from "@sscs/utils";
import { Controller, useFormContext, } from "react-hook-form";
import { useControlSize } from "../formDense";
import formLayout from "../formLayout.module.scss";
import { useRegisterRequiredField } from "../requiredFields";
import styles from "./textArea.module.scss";
function TextArea({ type = "text", size, variant = "outlined", isDisabled = false, isRequired = false, isReadOnly = false, isFullWidth = true, minRows = 3, ...props }) {
    const { control } = useFormContext();
    const resolvedSize = useControlSize(size);
    useRegisterRequiredField(isRequired);
    const { errorMessage, hasError } = extractFormFieldError(props.name, props === null || props === void 0 ? void 0 : props.errors);
    return (React.createElement(Controller, { name: props.name, control: control, render: ({ field }) => (React.createElement("div", { className: getClassName(styles.root, formLayout.field) },
            props.label && (React.createElement(MUIInputLabel, { htmlFor: props.id || props.name, error: hasError, required: isRequired, disabled: isDisabled }, props.label)),
            React.createElement(MUITextField, { onChange: (event) => {
                    var _a;
                    field.onChange(event);
                    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
                }, onBlur: () => {
                    var _a;
                    field.onBlur();
                    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
                }, value: field.value, name: field.name, multiline: true, maxRows: props.maxRows, minRows: minRows, id: props.id || props.name, inputRef: field.ref, type: type, variant: variant, size: resolvedSize, placeholder: props.placeholder, disabled: isDisabled, required: isRequired, fullWidth: isFullWidth, error: hasError, helperText: errorMessage || props.helperText, className: props.className, slotProps: {
                    input: {
                        readOnly: isReadOnly,
                    },
                } }))) }));
}
export default TextArea;
//# sourceMappingURL=TextArea.js.map